import { useState } from 'react'

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

/**
 * A hook similar to `useLexicalComposerContext`, but that rerenders when
 * something in the editor changes.
 */
export const useEditor = () => {
  const [editor] = useLexicalComposerContext()
  const [_dummy, setDummy] = useState<unknown>()

  useUnsafeEffect(() => {
    return editor.registerUpdateListener(() => {
      setDummy({})
    })
  }, [editor, setDummy])

  useUnsafeEffect(() => {
    return editor.registerEditableListener(() => {
      setDummy({})
    })
  }, [editor, setDummy])

  return editor
}
